<ng-container *ngIf="scenarioViewModel$ | async as scenario; else noScenario">
    <div class="w-full rounded-2xl p-6 shadow-sm">
        <div class="mb-6">
            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-200">
                {{ scenario.name }} <span class="text-sm font-normal text-slate-500 dark:text-slate-400">({{ scenario.code }})</span>
            </h3>
            <p class="text-sm text-slate-600 dark:text-slate-400 mt-1">
                {{ scenario.description }}
            </p>
        </div>

        <div class="relative" *ngIf="scenario.steps?.length; else noSteps">
            <!-- Vertical connecting line -->
            <div class="absolute left-4 top-4 bottom-4 w-px bg-gray-100 dark:bg-slate-700 -z-0"
                style="transform: translateX(-50%);"></div>

            <div class="flex flex-col gap-5 relative z-10">
                <div class="flex items-start gap-4"
                    *ngFor="let step of scenario.steps; let i = index; let isFirst = first">

                    <!-- Circle Indicator -->
                    <div class="w-8 h-8 rounded-full flex items-center justify-center shrink-0 bg-white dark:bg-slate-900 border-2 text-sm font-semibold shadow-sm mt-1"
                        [ngClass]="(scenario.selectedEtape === step.id.toString() || scenario.selectedEtape === step.code) ? 'border-green-500 text-green-500 dark:border-green-400 dark:text-green-400' : 'border-gray-200 text-gray-400 dark:border-slate-700 dark:text-slate-400'">
                        <ng-container *ngIf="(scenario.selectedEtape === step.id.toString() || scenario.selectedEtape === step.code); else notSelected">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                                stroke-linejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </ng-container>
                        <ng-template #notSelected>{{ i + 1 }}</ng-template>
                    </div>

                    <!-- Step Card -->
                    <div
                        (click)="selectEtape(step.id.toString())"
                        class="flex-1 border rounded-xl p-4 flex items-start justify-between gap-4 transition-colors cursor-pointer"
                        [ngClass]="scenario.selectedEtape === step.id.toString() || scenario.selectedEtape === step.code ? 'border-blue-500 bg-blue-50/50 dark:border-blue-500/50 dark:bg-blue-900/20' : 'border-slate-100 dark:border-slate-700/50 hover:bg-slate-100/50 dark:hover:bg-slate-700/30'">
                        <div>
                            <h4 class="text-sm font-bold text-slate-800 dark:text-slate-200 mb-1">{{ step.name }}</h4>
                            <p class="text-xs opacity-70 leading-relaxed">
                                <ng-container *ngFor="let folder of step.folders; let fIdx = index">
                                    {{ folder.label }}{{ fIdx < step.folders.length - 1 ? ', ' : '' }} </ng-container>
                            </p>
                        </div>

                        <div class="shrink-0">
                            <span
                                class="px-2 py-1 bg-blue-50/70 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded text-[11px] font-semibold border border-blue-100 dark:border-blue-800/50">
                                {{ step.folders.length }} dossier{{ step.folders.length > 1 ? 's' : '' }}
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</ng-container>

<!-- No scenario -->
<ng-template #noScenario>
    <div
        class="w-full rounded-2xl shadow-sm p-4 border border-dashed text-sm text-center text-slate-400 dark:text-slate-500 bg-white dark:bg-slate-900 border-gray-200 dark:border-slate-800">
        Aucun scénario sélectionné
    </div>
</ng-template>

<!-- No steps -->
<ng-template #noSteps>
    <div class="text-sm italic opacity-70 p-4 dark:text-slate-400">
        Aucune étape définie
    </div>
</ng-template>